import { PageContextType } from '../../types';

const supportedPageContextTypes = [
	PageContextType.CONFLUENCE_PAGE_VIEW,
	PageContextType.CONFLUENCE_PAGE_EDIT,
];

// this is based purely on the page context type
export const isPageContextTypeSupportedForDynamicStarters = (
	pageContextType: PageContextType,
): boolean => {
	return supportedPageContextTypes.includes(pageContextType);
};
